import type { IType } from '../types';
import type { IRegionCountry } from '@/pages/intelligence/types/common';

export const TYPES_MAPPING: {
  [key: string]: IType;
} = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};

export const HOT_COUNTRIES_PREFIX = '_hot';
export const HOT_COUNTRIES: IRegionCountry[] = [
  { country_code: 'cn_hot', country_name_en: 'China', country_name_ch: '中国' },
  { country_code: 'in_hot', country_name_en: 'India', country_name_ch: '印度' },
  { country_code: 'jp_hot', country_name_en: 'Japan', country_name_ch: '日本' },
  { country_code: 'kr_hot', country_name_en: 'South Korea', country_name_ch: '韩国' },
  { country_code: 'us_hot', country_name_en: 'United States', country_name_ch: '美国' },
  { country_code: 'gb_hot', country_name_en: 'United Kingdom', country_name_ch: '英国' },
  { country_code: 'ie_hot', country_name_en: 'Ireland', country_name_ch: '爱尔兰' },
  { country_code: 'nl_hot', country_name_en: 'Netherlands', country_name_ch: '荷兰' },
  { country_code: 'fr_hot', country_name_en: 'France', country_name_ch: '法国' },
];
